import { KJUR } from 'jsrsasign';

import Constants from '@/constants';

import { OktaUserRaw } from '@/types/types';

const STORAGE_KEY = 'impersonate-token';

const getImpersonatedToken = (): string | undefined => {
  const token = localStorage.getItem(STORAGE_KEY);
  return token ?? undefined;
};

export const getParsedImpersonatedToken = (): OktaUserRaw | undefined => {
  const token = getImpersonatedToken();
  if (!token) {
    return undefined;
  }
  return KJUR.jws.JWS.parse(token).payloadObj as OktaUserRaw;
};

export const setImpersonatedToken = (token?: string): void => {
  if (!token) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, token);
};

export const getFakeTokenHeader = (): Record<string, string> => {
  if (Constants.ENV === 'prod') {
    return {};
  }

  const token = getImpersonatedToken();
  if (!token) {
    return {};
  }

  return {
    'X-CFA-Impersonate': `Bearer ${token}`,
  };
};

export const setFakeTokenOnHeader = (headers: Headers) => {
  if (Constants.ENV === 'prod') {
    return;
  }

  const token = getImpersonatedToken();
  if (!token) {
    return;
  }

  headers.set('X-CFA-Impersonate', `Bearer ${token}`);
};

/**
 * Check if the app is currently impersonating a user.
 * Returns true if an impersonation token exists and we're not in production.
 */
export const isImpersonating = (): boolean => {
  if (Constants.ENV === 'prod') {
    return false;
  }
  return getImpersonatedToken() !== undefined;
};
